import { render, staticRenderFns } from "./ClientEditTabSettings.vue?vue&type=template&id=59eefbf6&"
import script from "./ClientEditTabSettings.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabSettings.vue?vue&type=style&index=0&id=59eefbf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports